import axios from "./axios";

export const getRecentSearch = async () => {
  try {
    const response = await axios.get(`/search/v1/recent?limit=5&offset=0`);
    return response.data.data;
  } catch (err) {
    throw new Error(err + " Failed to fetch events");
  }
};
